import { SelectField } from '@/shared/ui/field'

const ACCOUNT_PREFIX = 'account:'

interface OwnerFilterProps {
  /** Аккаунты-владельцы из каталога — по строке на каждый. */
  owners: string[]
  value: string
  onChange: (next: string) => void
  className?: string
}

/** Аккаунт из значения отбора; пусто у «все» и «платформенные». */
export function ownerFilterAccount(value: string): string {
  return value.startsWith(ACCOUNT_PREFIX) ? value.slice(ACCOUNT_PREFIX.length) : ''
}

export const OWNER_FILTER_PLATFORM = 'platform'

// Отбор каталога по владельцу: «все», «платформенные» (пустой owner) и по
// строке на аккаунт из каталога. Служебные пункты и id аккаунта живут в одном
// селекте, поэтому id несёт префикс — иначе аккаунт «platform» слился бы с пунктом.
export function OwnerFilter({ owners, value, onChange, className }: OwnerFilterProps) {
  return (
    <SelectField
      label="Владелец"
      className={className}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">Все владельцы</option>
      <option value={OWNER_FILTER_PLATFORM}>Платформенные</option>
      {owners.map((id) => (
        <option key={id} value={`${ACCOUNT_PREFIX}${id}`}>
          {id}
        </option>
      ))}
    </SelectField>
  )
}
